export default __webpack_public_path__ + "static/media/content1.2c741ecf.jpg";